import { CollectedDataStatus } from 'src/constants/collectedData'
import { CustomerCollectedDataStatus } from 'src/constants/customer/enums'
import { ContractorStepDetailsCardStatus } from './types'
import type { CardStatusType } from './types'

export function mapCollectedDataStatusToCardStatus(
  status: CollectedDataStatus,
): ContractorStepDetailsCardStatus {
  switch (status) {
    case CollectedDataStatus.Created:
      return ContractorStepDetailsCardStatus.NotStarted
    case CollectedDataStatus.InProgress:
      return ContractorStepDetailsCardStatus.InProgress
    case CollectedDataStatus.WaitingForInternalApproval:
      return ContractorStepDetailsCardStatus.Pending
    case CollectedDataStatus.WaitingForApproval:
      return ContractorStepDetailsCardStatus.WaitingForApproval
    case CollectedDataStatus.Completed:
      return ContractorStepDetailsCardStatus.Approved
    case CollectedDataStatus.Failed:
      return ContractorStepDetailsCardStatus.Failed
    case CollectedDataStatus.Expired:
      return ContractorStepDetailsCardStatus.Expired
    default:
      return ContractorStepDetailsCardStatus.NotStarted
  }
}

export function mapMCStatusToCardStatus(
  status: CustomerCollectedDataStatus,
): ContractorStepDetailsCardStatus {
  switch (status) {
    case CustomerCollectedDataStatus.Created:
      return ContractorStepDetailsCardStatus.NotStarted
    case CustomerCollectedDataStatus.InProgress:
      return ContractorStepDetailsCardStatus.InProgress
    case CustomerCollectedDataStatus.WaitingForInternalApproval:
      return ContractorStepDetailsCardStatus.Pending
    case CustomerCollectedDataStatus.Completed:
      return ContractorStepDetailsCardStatus.Approved
    case CustomerCollectedDataStatus.Failed:
      return ContractorStepDetailsCardStatus.Failed
    case CustomerCollectedDataStatus.Expired:
      return ContractorStepDetailsCardStatus.Expired
    case CustomerCollectedDataStatus.Archived:
      return ContractorStepDetailsCardStatus.NotStarted
    default:
      return ContractorStepDetailsCardStatus.NotStarted
  }
}

export function getCardStatus(status: ContractorStepDetailsCardStatus): CardStatusType {
  if (status === ContractorStepDetailsCardStatus.Approved) {
    return 'Valid'
  }

  return 'NotValid'
}
